<div class="cv" *ngIf="items?.length" role="region" aria-label="Catalogue items">
  <div class="cv__bar"></div>

  <div class="cv__head">
    <div class="cv__icon"><mat-icon>inventory_2</mat-icon></div>
    <div class="cv__headtext">
      <div class="cv__title">{{ heading }}</div>
      <div class="cv__sub">
        <b>{{ items.length }}</b> item<span *ngIf="items.length !== 1">s</span>
        <span *ngIf="equipment"> on <b>{{ equipment }}</b></span>
        <span *ngIf="pendingCount"> · {{ pendingCount }} awaiting approval</span>
        <span *ngIf="liveCount"> · {{ liveCount }} live</span>
      </div>
    </div>
  </div>

  <div class="cv__list">
    <div class="cv-item" *ngFor="let it of visible; let i = index"
         [style.animation-delay]="(i * 45) + 'ms'">
      <div class="cv-item__main">
        <span class="cv-item__name">{{ it.name }}</span>
        <span class="cv-chip" [ngClass]="stateClass(it.state)">{{ stateLabel(it.state) }}</span>
      </div>
      <div class="cv-item__meta">
        <span *ngIf="it.partNumber"><b>Part</b> {{ it.partNumber }}</span>
        <span *ngIf="it.makerPartNo"><b>Maker part</b> {{ it.makerPartNo }}</span>
        <span *ngIf="it.supplierPartNo"><b>Supplier part</b> {{ it.supplierPartNo }}</span>
        <span *ngIf="it.drawingNo"><b>Dwg</b> {{ it.drawingNo }}</span>
        <span *ngIf="it.positionNo"><b>Pos</b> {{ it.positionNo }}</span>
        <span *ngIf="it.partType"><b>Type</b> {{ it.partType }}</span>
        <span *ngIf="it.sfiCode"><b>SFI</b> {{ it.sfiCode }}</span>
      </div>
      <div class="cv-item__meta">
        <span *ngIf="it.equipmentName"><b>Equipment</b> {{ it.equipmentName }}</span>
        <span *ngIf="it.equipmentManufacturer"><b>Maker</b> {{ it.equipmentManufacturer }}</span>
        <span *ngIf="it.equipmentModel"><b>Model</b> {{ it.equipmentModel }}</span>
        <span *ngIf="it.equipmentSerialNo"><b>Serial</b> {{ it.equipmentSerialNo }}</span>
        <span *ngIf="it.equipment && !equipment"><b>On</b> {{ it.equipment }}</span>
      </div>
    </div>
  </div>

  <button type="button" class="cv__more" *ngIf="items.length > 6"
          (click)="expanded = !expanded">
    <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    {{ expanded ? 'Show fewer' : 'Show all ' + items.length }}
  </button>

  <div class="cv__foot" *ngIf="pendingCount">
    <mat-icon>schedule</mat-icon>
    Awaiting items are not visible to buyers yet. Once an admin approves them
    they go live and can be assigned to your profile.
  </div>
  <div class="cv__foot cv__foot--live" *ngIf="!pendingCount">
    <mat-icon>visibility</mat-icon>
    These are live on MPS — buyers can find them in search and add them to an RFQ.
  </div>
</div>
